import { atom } from "recoil";
import { panelPaymentsLogStore } from "./panelPaymentsLog";

export const reasonsWithdrawalsForDenial = [
	"Wager_X3",
	"Wager_Slot",
	"Wager_X5",
	"Wager_X10",
	"Wager_X20",
	"Wager_X30",
	"Wager_Weekly_X1.5",
	"8.4.2_Х30",
	"No_Money",
	"Bank_Error",
	"Spam",
	"Checking_Win",
	"Contact_Affilate",
	"Affilatе_fiat",
	"Need_proof_deposits",
	"Description_in_the_panel",
	"8.3.1",
	"8.3.6",
	"8.3_Before_dep",
	"8.3.1_Before_dep",
	"8.3_Race",
	"8.5",
	"8.5.1",
	"8.5.2",
	"8.5.3",
	"8.4.2",
	"3.1.2.18",
	"3.1.2.22_Rakeback",
	"3.1.2.2",
	"3.1.2.3",
	"5.13.1_Day",
	"5.13.1_Week",
	"5.13.1_Month",
	"5.13.2_Day",
	"5.13.2_Week",
	"5.13.2_Month",
	"5.13.3_Day",
	"5.13.3_Week",
	"5.13.3_Month",
	"5.13.4_Day",
	"5.13.4_Week",
	"5.13.4_Month",
	"5.13.5_Day",
	"5.13.5_Week",
	"5.13.5_Month",
	"5.13.6_Day",
	"5.13.6_Week",
	"5.13.6_Month",
	"5.13.7_Day",
	"5.13.7_Week",
	"5.13.7_Month",
	"5.13.8_Day",
	"5.13.8_Week",
	"5.13.8_Month",
	"5.13.9_Day",
	"5.13.9_Week",
	"5.13.9_Month",
];

function getPeriodConfig(period) {
	const now = new Date();
	const currentDay = now.getDay();
	const currentDate = now.getDate();
	const currentMonth = now.getMonth();
	const currentYear = now.getFullYear();

	const daysInPrevMonth = new Date(currentYear, currentMonth, 0).getDate();

	const daysSinceWeekStart = (currentDay + 6) % 7;

	switch (period) {
		case "This week":
			return { offset: 0, limit: daysSinceWeekStart + 1 };
		case "Prev week":
			return { offset: daysSinceWeekStart + 1, limit: 7 };
		case "This month":
			return { offset: 0, limit: currentDate };
		case "Prev month":
			return { offset: currentDate, limit: daysInPrevMonth };
		case "Half of year":
			return { offset: 0, limit: Math.floor((now - new Date(currentYear, 0, 1)) / (1000 * 60 * 60 * 24)) + 1 };
		case "This year":
			return { offset: 0, limit: Math.floor((now - new Date(currentYear, 0, 1)) / (1000 * 60 * 60 * 24)) + 1 };
		case "Prev year":
			return { offset: Math.floor((now - new Date(currentYear, 0, 1)) / (1000 * 60 * 60 * 24)) + 1, limit: 365 };
	}
}

export const configStore = atom({
	key: "configStore",
	default: {
		app: {
			name: JSON.parse(localStorage.getItem("access.brand")) ? JSON.parse(localStorage.getItem("access.brand")).name : "XPanel",
		},
		apiServlet: window.location.href.indexOf("127.0.0.1") !== -1 || window.location.href.indexOf("localhost") !== -1 ? "http://127.0.0.1:4444/v1/" : process.env.REACT_APP_API_SERVLET,
		paymentApi: {
			servlet: "https://private.ecorpay.net",
			id: JSON.parse(localStorage.getItem("access.brand")) ? JSON.parse(localStorage.getItem("access.brand")).ecorpayID : 0,
		},
		routerApi: {
			servlet: "https://elsikora-api.com",
			id: JSON.parse(localStorage.getItem("access.brand")) ? JSON.parse(localStorage.getItem("access.brand")).elsikoraID : 0,
		},
		updated: 1793717990453,
		version: "8.60",
		domain: "",
		playerHidePayway:{
			perPage: localStorage.getItem("playerHidePayway.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		playerBan:{
			perPage: localStorage.getItem("playerBan.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		playerRulesAutomaticLog:{
			perPage: localStorage.getItem("playerRulesAutomaticLog.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		panelPaymentsUsers: {
			perPage: localStorage.getItem("panelPaymentsUsers.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		group: {
			perPage: localStorage.getItem("group.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		panelPaymentsLogStore: {
			perPage: localStorage.getItem("panelPaymentsLogStore.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		gameSection: {
			perPage: localStorage.getItem("gamesSection.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		badges: {
			perPage: localStorage.getItem("badges.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		provider: {
			perPage: localStorage.getItem("provider.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		client: {
			perPage: localStorage.getItem("client.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		game: {
			perPage: localStorage.getItem("games.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			options: {
				integrator: [
					{ value: "All integrators", type: "all" },
					{ value: "SoftSwiss", type: "softswiss" },
					{ value: "QTech", type: "qtech" },
					{ value: "Slotegrator", type: "slotegrator" },
					{ value: "Endorphina", type: "endorphina" },
					{ value: "Infin", type: "infin" },
					{ value: "Softgamings", type: "softgamings" },
					{ value: "Internal", type: "internal" },
				],
				provider: [],
				category: [],
				status: [
					{ value: "All games", type: false },
					{ value: "Enabled", type: "enabled" },
					{ value: "Disabled", type: "disabled" },
				],
				automanageTypes: [
					{ value: "QTech", type: "qtech" },
					{ value: "Slotegrator", type: "slotegrator" },
					{ value: "Softswiss", type: "softswiss" },
					{ value: "Infin", type: "infin" },
					{ value: "Softgamings", type: "softgamings" },
					{ value: "Spinomenal", type: "spinomenal" },
				],
			},
		},
		staff: {
			perPage: localStorage.getItem("staff.perPage") || 10,
			preferences: {
				perPage: [
					{ value: 10, label: "10" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			sessions: {
				perPage: localStorage.getItem("staff.sessions.perPage") || 15,
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			log: {
				perPage: localStorage.getItem("staff.log.perPage") || 15,
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
		},
		domains: {
			perPage: localStorage.getItem("domains.perPage") || 10,
			preferences: {
				perPage: [
					{ value: 10, label: "10" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			options: {
				type: [
					{ value: "Project domain", type: "domain" },
					{ value: "Mirror domain", type: "mirror" },
					{ value: "Banned domain", type: "ban" },
					{ value: "Current project domain", type: "current" },
					{ value: "Current mirror domain", type: "mirrorCurrent" },
					{ value: "PWA domain", type: "pwa" },
					{ value: "Current PWA domain", type: "pwaCurrent" },
					{ value: "Auth Domain", type: "auth" },
					{ value: "Current Auth Domain", type: "currentAuth" },
				],
			},
		},
		playerRules: {
			perPage: localStorage.getItem("playerRules.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		playerTag: {
			perPage: localStorage.getItem("playerTag.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		players: {
			perPage: localStorage.getItem("players.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			options: {
				type: [
					{ value: "By UID", type: "uid" },
					{ value: "By casinoID", type: "casinoid" },
					{ value: "By IP", type: "ip" },
					{ value: "By refer", type: "refer" },
					{ value: "By misc", type: "misc" },
					{ value: "By withdrawal wallet", type: "withdrawal_wallet" },
					{ value: "By withdrawal id", type: "withdrawal_id" },
					{ value: "By deposit id", type: "deposit" },
					{ value: "By social account", type: "social" },
				],
				order: [
					{ value: "By balance", type: "balance" },
					{ value: "By rakeback balance", type: "balance_rakeback" },
					{ value: "By partner balance", type: "balance_r" },
					{ value: "TOP 500 depositors", type: "deposits" },
					{ value: "TOP 500 withdrawals", type: "withdrawals" },
				],
				direction: [
					{ value: "Descending", type: "desc" },
					{ value: "Ascending", type: "asc" },
				],
			},
			log: {
				perPage: localStorage.getItem("players.log.perPage") || 50,
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			multiWithdrawals: {
				defaultPerPage: 50,
				perPageByProject: {},
				preferences: {
					perPage: [
						{ value: 5, label: "5" },
						{ value: 10, label: "10" },
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			multiPlayers: {
				defaultPerPage: 50,
				perPageByProject: {},
				preferences: {
					perPage: [
						{ value: 5, label: "5" },
						{ value: 10, label: "10" },
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			gameLog: {
				defaultPerPage: 15,
				perPageByProject: {},
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			sessions: {
				defaultPerPage: 15,
				perPageByProject: {},
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			gameLogShort: {
				perPage: localStorage.getItem("players.gameLog.short.perPage") || 5,
				preferences: {
					perPage: [
						{ value: 5, label: "5" },
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
					],
				},
			},
			payments: {
				perPage: localStorage.getItem("players.payments.perPage") || 15,
				preferences: {
					perPage: [
						{ value: 15, label: "15" },
						{ value: 30, label: "30" },
						{ value: 50, label: "50" },
						{ value: 100, label: "100" },
						{ value: 200, label: "200" },
					],
				},
			},
			bonuses: {
				sweepstakesActive: {
					perPage: localStorage.getItem("players.bonuses.sweepstakesActive.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				sweepstakesHistory: {
					perPage: localStorage.getItem("players.bonuses.sweepstakesHistory.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				fortuneWheel: {
					perPage: localStorage.getItem("players.bonuses.fortuneWheel.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				allPromocode: {
					perPage: localStorage.getItem("players.bonuses.promocode.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				promocode: {
					perPage: localStorage.getItem("players.bonuses.promocode.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				rain: {
					perPage: localStorage.getItem("players.bonuses.rain.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				achievementsActive: {
					perPage: localStorage.getItem("players.bonuses.achievementsActive.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
				achievementsHistory: {
					perPage: localStorage.getItem("players.bonuses.achievementsHistory.perPage") || 15,
					preferences: {
						perPage: [
							{ value: 15, label: "15" },
							{ value: 30, label: "30" },
							{ value: 50, label: "50" },
							{ value: 100, label: "100" },
							{ value: 200, label: "200" },
						],
					},
				},
			},
		},
		withdrawals: {
			perPage: localStorage.getItem("withdrawals.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			buttons: localStorage.getItem("withdrawals.buttons") ? [...new Set([...reasonsWithdrawalsForDenial, ...JSON.parse(localStorage.getItem("withdrawals.buttons"))])] : reasonsWithdrawalsForDenial,
		},
		brandLicenses: {
			perPage: localStorage.getItem("brandLicenses.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			}
		},
		achievementCategory: {
			perPage: localStorage.getItem("achievementCategory.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			}
		},
		prize: {
			perPage: localStorage.getItem("prize.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			}
		},
		chestPrize: {
			perPage: localStorage.getItem("chestPrize.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			}
		},
		achievement: {
			perPage: localStorage.getItem("achievement.perPage") || 15,
				preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			}
		},
		promotion: {
			perPage: localStorage.getItem("promotion.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		walletPromotion: {
			perPage: localStorage.getItem("walletPromotion.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		walletGroups: {
			perPage: localStorage.getItem("walletGroups.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		depositLadder: {
			perPage: localStorage.getItem("depositLadder.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
				],
			},
		},
		tgBots: {
			perPage: localStorage.getItem("tgBots.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		webhookBroadcasts: {
			perPage: localStorage.getItem("webhookBroadcasts.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		webhookPresets: {
			perPage: localStorage.getItem("webhookPresets.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		bonuses: {
			perPage: localStorage.getItem("bonuses.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			main: {
				options: {
					type: [
						{ value: "By id", type: "id" },
						{ value: "By UID", type: "uid" },
						{ value: "By name", type: "code" },
						{ value: "By value", type: "value" },
						{ value: "By type", type: "type" },
						{ value: "By note", type: "note" },
					],
					order: [
						{ value: "By id", type: "id" },
						{ value: "By UID", type: "uid" },
						{ value: "By code", type: "code" },
						{ value: "By value", type: "value" },
						{ value: "By type", type: "type" },
					],
					direction: [
						{ value: "Descending", type: "desc" },
						{ value: "Ascending", type: "asc" },
					],
				},
			},
			options: {
				type: [
					{ value: "Public", type: 0 },
					{ value: "Affiliative", type: 1 },
					{ value: "Dedicated", type: 2 },
				],
			},
		},
		chatPinned: {
			perPage: localStorage.getItem("chatPinned.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		fortuneWheelModal: {
			perPage: localStorage.getItem("players.fortuneWheelModal.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		fortuneWheel: {
			perPage: localStorage.getItem("players.fortuneWheel.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		blackListWithdrawals: {
			perPage: localStorage.getItem("players.blackListWithdrawals.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		whiteListPlayersWithdrawals: {
			perPage: localStorage.getItem("players.whiteListPlayersWithdrawals.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		playerBalanceLog: {
			perPage: localStorage.getItem("players.playerBalanceLog.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		userActionLog: {
			perPage: localStorage.getItem("players.userActionLog.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		blackListLogWithdrawals: {
			perPage: localStorage.getItem("players.blackListLogWithdrawals.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
			options: {
				type: [
					{ value: "By UID", type: "uid" },
					{ value: "By withdrawal id", type: "withdrawalID" },
					{ value: "By project", type: "project" },
				],
			},
		},
		banners: {
			perPage: localStorage.getItem("banners.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		homeBanners: {
			perPage: localStorage.getItem("homeBanners.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		analyticsBanners: {
			perPage: localStorage.getItem("analyticsBanners.perPage") || 10,
			preferences: {
				perPage: [
					{ value: 10, label: "10" },
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
				],
			},
		},
		analyticsMenuBanners: {
			perPage: localStorage.getItem("analyticsMenuBanners.perPage") || 10,
			preferences: {
				perPage: [
					{ value: 10, label: "10" },
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
				],
			},
		},
		tournaments: {
			perPage: localStorage.getItem("tournaments.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		gameLogDetail: {
			perPage: localStorage.getItem("gameLogDetail.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		stats: {
			options: {
				period: [
					{ value: "Today", type: { offset: 0, limit: 1 } },
					{ value: "Yesterday", type: { offset: 1, limit: 1 } },
					{ value: "This week", type: getPeriodConfig("This week") },
					{ value: "Prev week", type: getPeriodConfig("Prev week") },
					{ value: "This month", type: getPeriodConfig("This month") },
					{ value: "Prev month", type: getPeriodConfig("Prev month") },
					{ value: "Half of year", type: getPeriodConfig("Half of year") },
					{ value: "This year", type: getPeriodConfig("This year") },
					{ value: "Prev year", type: getPeriodConfig("Prev year") },
				],
				delimiter: [
					{ value: "Per day", type: 1 },
					{ value: "Per week", type: 7 },
					{ value: "Per month", type: 30 },
					{ value: "Per year", type: 365 },
				],
				delimiterFull: [
					{ value: "Per 5 minutes", type: 300 },
					{ value: "Per 15 minutes", type: 900 },
					{ value: "Per 1 hour", type: 3600 },
					{ value: "Per 1 day", type: 86400 },
				],
				delimiterProvider: [
					{ value: "Per 1 hour", type: "hour" },
					{ value: "Per day", type: 1 },
					{ value: "Per week", type: 7 },
					{ value: "Per month", type: 30 },
					{ value: "Per year", type: 365 },
				],
				payway: [],
			},
		},
		pstats: {
			options: {
				period: [
					{ value: "Today", type: { offset: 0, limit: 1 } },
					{ value: "Yesterday", type: { offset: 1, limit: 1 } },
					{ value: "This week", type: getPeriodConfig("This week") },
					{ value: "Prev week", type: getPeriodConfig("Prev week") },
					{ value: "This month", type: getPeriodConfig("This month") },
					{ value: "Prev month", type: getPeriodConfig("Prev month") },
					{ value: "Half of year", type: getPeriodConfig("Half of year") },
					{ value: "This year", type: getPeriodConfig("This year") },
					{ value: "Prev year", type: getPeriodConfig("Prev year") },
				],
				delimiter: [
					{ value: "Per day", type: 1 },
					{ value: "Per week", type: 7 },
					{ value: "Per month", type: 30 },
					{ value: "Per year", type: 365 },
				],
				payway: [],
			},
		},
		reports: {
			options: {
				currency: [
					{ value: "RUB", type: "RUB" },
					{ value: "USD", type: "USD" },
					{ value: "EUR", type: "EUR" },
				],
				group: [
					{ type: "all", value: "All groups" },
					{ type: "providers", value: "Providers" },
					{ type: "infrastructure", value: "Infrastructure" },
					{ type: "marketing", value: "Marketing" },
					{ type: "laws", value: "Laws" },
					{ type: "service", value: "Service" },
					{ type: "outsource", value: "Outsource" },
					{ type: "domains", value: "Domains" },
					{ type: "fee", value: "Fee" },
					{ type: "vacancy", value: "Vacancy" },
					{ type: "resume", value: "Resume" },
					{ type: "meetings", value: "Meetings" },
					{ type: "invests", value: "Invests" },
					{ type: "businessTrips", value: "Business trips" },
					{ type: "equipment", value: "Equipment" },
					{ type: "training", value: "Training" },
					{ type: "links", value: "Links" },
					{ type: "salaries", value: "Salaries" },
					{ type: "streamers", value: "Streamers" },
					{ type: "testDeposits", value: "Test deposits" },
					{ type: "testEmployees", value: "Test Employees" },
					{ type: "advertisment", value: "Advertisment" },
					{ type: "commission", value: "Commission" },
					{ type: "license", value: "License" },
					{ type: "drops", value: "Drops" },
					{ type: "other", value: "Other" },
				],
			},
		},
		freespins: {
			perPage: localStorage.getItem("freespins.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
		freespinsRules: {
			perPage: localStorage.getItem("freespinsRules.perPage") || 15,
			preferences: {
				perPage: [
					{ value: 15, label: "15" },
					{ value: 30, label: "30" },
					{ value: 50, label: "50" },
					{ value: 100, label: "100" },
					{ value: 200, label: "200" },
				],
			},
		},
	},
});
